import { DropDownWithLabelModel } from "./dropDown";

export enum PreviousInsurerNameTypes {
    NOT_APPLICABLE = "NOT_APPLICABLE",
    ALLIANZ = "ALLIANZ",
    AVIVA = "AVIVA",
    BALCIA = "BALCIA",
    COMPENSA = "COMPENSA",
    CREDIT_AGRICOLE = "CREDIT_AGRICOLE",
    ERGO_HESTIA = "ERGO_HESTIA",
    GENERALI = "GENERALI",
    GOTHAER = "GOTHAER",
    INTERRISK = "INTERRISK",
    LINK4 = "LINK4",
    OTHER = "OTHER",
    PZU = "PZU",
    TUE = "TUE",
    TU_INTER = "TU_INTER",
    TUIR = "TUIR",
    TUW_TUW = "TUW_TUW",
    TUZ_TUW = "TUZ_TUW",
    UNIQUA = "UNIQUA",
    WIENER = "WIENER"
}

export const PreviousInsurerNameDropDown: DropDownWithLabelModel = {
    label: "Nazwa poprzedniego zakładu ubezpieczeń dla nowych klientów",
    dropDown: [
        {
            id: PreviousInsurerNameTypes.TUZ_TUW,
            displayName: "TUZ Ubezpieczenia (TUZ TUW)"
        },
        {
            id: PreviousInsurerNameTypes.ALLIANZ,
            displayName: "Allianz Polska S.A."
        },
        {
            id: PreviousInsurerNameTypes.AVIVA,
            displayName: "Aviva Towarzystwo Ubezpieczeń Ogólnych S.A."
        },
        {
            id: PreviousInsurerNameTypes.BALCIA,
            displayName: "BALCIA INSURANCE"
        },
        {
            id: PreviousInsurerNameTypes.COMPENSA,
            displayName: "COMPENSA TU S.A. Vienna Insurance Group"
        },
        {
            id: PreviousInsurerNameTypes.CREDIT_AGRICOLE,
            displayName: "CREDIT AGRICOLE TU S.A."
        },
        {
            id: PreviousInsurerNameTypes.ERGO_HESTIA,
            displayName: "Ergo Hestia S.A."
        },
        {
            id: PreviousInsurerNameTypes.GENERALI,
            displayName: "Generali  TU S.A."
        },
        {
            id: PreviousInsurerNameTypes.GOTHAER,
            displayName: "GOTHAER Towarzystwo Ubezpieczeń S.A."
        },
        {
            id: PreviousInsurerNameTypes.INTERRISK,
            displayName: "InterRisk TU S.A. Vienna Insurance Group"
        },
        {
            id: PreviousInsurerNameTypes.LINK4,
            displayName: "Link4 TU S.A."
        },
        {
            id: PreviousInsurerNameTypes.PZU,
            displayName: "PZU S.A."
        },
        {
            id: PreviousInsurerNameTypes.TUE,
            displayName: "Towarzystwo Ubezpieczeń Europa S.A."
        },
        {
            id: PreviousInsurerNameTypes.TU_INTER,
            displayName: "TU INTER POLSKA S.A."
        },
        {
            id: PreviousInsurerNameTypes.TUIR,
            displayName: "TUiR WARTA S.A."
        },
        {
            id: PreviousInsurerNameTypes.TUW_TUW,
            displayName: "TUW TUW"
        },
        {
            id: PreviousInsurerNameTypes.UNIQUA,
            displayName: "UNIQA TU S.A."
        },
        {
            id: PreviousInsurerNameTypes.WIENER,
            displayName: "WIENER TU S.A."
        },
        {
            id: PreviousInsurerNameTypes.OTHER,
            displayName: "INNE"
        },
        {
            id: PreviousInsurerNameTypes.NOT_APPLICABLE,
            displayName: "Nie dotyczy"
        }
    ]
};
